import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectCard from "../../molecules/ProjectDetailsCard";
import useScrollToTop from "../../../hooks/useScrollToTop";
import { fetchProjectById } from "../../../utils/API/fetchProjectById";
import { useDispatch } from "react-redux";
import { fetchProjects } from "../../../utils/API/fetchProjects";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../atoms/SearchButton";
import { Skeleton } from "antd";
import Button from "../../atoms/Button";
import FilterDialogBox from "../../molecules/FilterDialogBox";
import { ReactComponent as Filter } from "../../../components/svgs/Filterrblack.svg";
import BuyerProjectCard from "../../atoms/BuyerProjectCard";
import ProjectListLoader from "../../atoms/ProjectListLoader";
import { useSelector } from "react-redux";
import InquireNotificationDialog from "../../molecules/HomePageDialogs/InquireNotificationDialog";
import InquireConfirmation from "../../molecules/HomePageDialogs/InquireConfirmation";
import KycDialogBox from "../../molecules/HomePageDialogs/KycDialogBox";
import { inquireRequest } from "../../../utils/API/inquireRequest";
import toast from "react-hot-toast";
import Pagination from "../../atoms/Pagination";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";

const ProjectDetails = ({ onBid, onInquire }) => {
  useScrollToTop();
  const dispatch = useDispatch();
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false);
  const [showProject, setShowProject] = useState(true);
  const [projectData, setProjectData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const projectId = searchParams.get("projectId") || "";
  const userId = searchParams.get("userId") || "";
  const [projectsData, setProjectsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentPage = Number(searchParams.get("page")) || 1;
  const navigate = useNavigate();
  const [inquireConfirmState, setInquireConfirmState] = useState(false);
  const { userType, kycVerified } = useSelector((state) => state.authReducer);
  const [inquireNotificationState, setInquireNotificationState] =
    useState(false);
  const [kycDialogState, setKycDialogState] = useState(false);
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProjectVintage, setSelectedProjectVintage] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [selectedCreditType, setSelectedCreditType] = useState(null);
  const [selectedTypeOfTransaction, setSelectedTypeOfTransaction] =
    useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [searchItem, setSearchItem] = useState("");
  const [lowPrice, setLowPrice] = useState("0");
  const [highPrice, setHighPrice] = useState("50");
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  });

  const inquireHandler = async (formData) => {
    if (userType === null) {
      setInquireNotificationState(true);
    } else if (userType === "seller") {
      setInquireNotificationState(true);
    } else if (!kycVerified) {
      setKycDialogState(true);
    } else {
      try {
        await inquireRequest({ formData }, dispatch);
        setInquireConfirmState(true);
      } catch (error) {
        toast.error("Inquiry failed: " + error.message);
      }
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchProjects(
        {
          filterData: filterData,
          page: currentPage,
          pageSize: 10,
          searchQuery: searchItem
        },
        dispatch
      );
      const responseData = response.data;
      setProjectsData(responseData.paginatedData);
      const { totalDocs, totalPages } = responseData;
      setPagination({
        totalItems: totalDocs,
        totalPages: totalPages
      });
    } catch (err) {
      setError("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentPage, filterData, , searchItem]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchProjectById(projectId, userId, dispatch);
        setProjectData(data[0]);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [projectId, userId]);

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null);
    setSelectedCategory(null);
    setSelectedProjectVintage(null);
    setSelectedToken(null);
    setSelectedCreditType(null);
    setSelectedCountry(null);
    setFilterData(null);
    setSelectedTypeOfTransaction(null);
    setFilterDialogOpen(false);
    setSelectedType(null);
    setSelectedUserType(null);
    setLowPrice("0");
    setHighPrice("50");
  };

  const handleRegistryCheck = (e) => {
    {
      const selectedValue = e.target.value;
      setSelectedRegistry(selectedValue);
    }
  };

  const handleSearch = () => {
    // console.log(searchItem);
  };

  const handleTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedType(selectedValue);
  };

  const handleUserTypeCheck = (e) => {
    const selectedValue = e.target.value;
    setSelectedUserType(selectedValue);
  };

  const handleTokenCheck = (e) => {
    const selectedToken = e.target.value;
    setSelectedToken(selectedToken);
  };

  const handleCreditType = (e) => {
    const selectedCreditType = e.target.value;
    setSelectedCreditType(selectedCreditType);
  };

  const handleTypeOfTransaction = (e) => {
    const selectedTypeOfTransaction = e.target.value;
    setSelectedTypeOfTransaction(selectedTypeOfTransaction);
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setSelectedCountry(selectedCountry);
  };

  const handleProjectVintageChange = (e) => {
    const selectedProjectVintage = e.target.value;
    setSelectedProjectVintage(selectedProjectVintage);
  };

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false);
    if (showProject) {
      setFilterData({
        registries: selectedRegistry ? [selectedRegistry] : null,
        categoryId: selectedCategory,
        // ProjectVintageId: selectedProjectVintage,
        country: selectedCountry,
        tokenTypes: selectedToken ? [selectedToken] : null,
        creditType: selectedCreditType,
        typeOfTransaction: selectedTypeOfTransaction,
        priceLow: lowPrice,
        priceHigh: highPrice
      });
    } else {
      setFilterData({
        type: selectedType ? selectedType : null,
        user_type: selectedUserType ? selectedUserType : null
      });
    }
  };

  return (
    <>
      <div className="w-full flex gap-x-10">
        <div className="bg-grey-100 flex flex-col w-2/3 2xl:w-2/3 md:w-3/5">
          <div className="flex">
            <div className="w-4/5 h-[40px] flex p-1 ml-[1rem]  mt-4 rounded-lg">
              <SearchBar
                onSearch={handleSearch}
                searchItem={searchItem}
                setSearchItem={setSearchItem}
                variant="secondaryxl"
                className="text-black w-full h-full"
                borderColor="border-none"
                placeholderColor="blue-800"
                inputBackground="blue"
                svgStrokeColor="blue"
                inputWidth="full"
                inputHeight="9"
              />
            </div>
            <div className="ml-[1rem] mt-5 whitespace-nowrap">
              <Button
                onClick={() => {
                  navigate("/all-carbon-credit");
                }}
                variant="primary"
                borderColor="blue"
                className="px-10 w-30 font-bold py-[6px] text-sm rounded-md text-white bg-blue-800"
              >
                See All
              </Button>
            </div>
          </div>
          <div className=" ml-[1rem]  mb-4 ">
            <div>
              {!projectData ? (
                <div className="flex flex-col gap-y-4 p-4">
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                </div>
              ) : (
                <ProjectCard
                  _id={projectData._id}
                  userTitle={projectData.userData.userName}
                  blockchain_detail={projectData?.project?.blockchain_detail}
                  projectTitle={projectData.project.projectName}
                  projectLocation={`${projectData?.project?.location?.state}, ${projectData?.project?.location?.country}`}
                  credits={`Listed Credits - ${projectData?.no_of_credits_to_sell}`}
                  type={projectData?.project?.typeOfCredit}
                  tokenType={projectData?.project?.tokenType}
                  projectImage={projectData?.project?.cover_image}
                  creditListed={`$${projectData?.price_per_credit} / credit`}
                  OGscore={`OG score ${projectData?.project?.ogScore}`}
                  projectCategory={
                    projectData?.project?.categoryDetails.categoryName
                  }
                  SDG_contribution={projectData?.project?.SDG_contribution}
                  holdingsId={projectData?.holdingsId}
                  isListed={projectData?.isListed}
                  creditTransaction={projectData?.credit_transaction}
                  totalCredits={projectData?.numberOfCredits}
                  registry={projectData?.project.registryDetails}
                  about_project={projectData?.project.about_project}
                  project_impact_and_benefits={
                    projectData?.project.project_impact_and_benefits
                  }
                  InquireHandler={inquireHandler}
                />
              )}
            </div>
          </div>
        </div>
        <div className="pl-3 w-1/3">
          <div className=" flex justify-between pt-8  pb-4">
            <div className="flex justify-between text-lg font-bold">
              You might also like
            </div>
            <div className="">
              <Button
                varient="rounded"
                borderColor="black"
                onClick={() => setFilterDialogOpen(true)}
                className="w-40 focus-visible:outline-0 text-xl font-normal justify-center pl-1 py-1  bg-blue-200  flex items-center"
              >
                Filter{" "}
                <span className="pl-12">
                  <Filter />
                </span>
              </Button>
            </div>
          </div>
          {loading ? (
            <ProjectListLoader />
          ) : (
            projectsData?.map((project, idx) => (
              <div className="mb-4" key={`project_${idx}`}>
                <BuyerProjectCard
                  {...project}
                  InquireHandler={onInquire}
                  bidHandler={onBid}
                  isProjectDescription={true}
                  searchItem={searchItem}
                />
              </div>
            ))
          )}
          <Pagination
            current={currentPage}
            total={pagination.totalItems}
            pageSize={10}
            setCurrentPage={(page) => setSearchParams({ page })}
          />
          <div className=" flex my-3 justify-center ">
            <Button
              onClick={() => {
                navigate("/all-carbon-credit");
              }}
              variant="primary"
              borderColor="blue"
              className="px-10 w-full font-bold py-[6px] text-sm rounded-md text-white bg-blue-800"
            >
              See More
            </Button>
          </div>
        </div>
        {isFilterDialogOpen && (
          <FilterDialogBox
            open={isFilterDialogOpen}
            onCancel={handleFilterDialogClose}
            onOk={handleFilterDialogSubmit}
            selectedRegistry={selectedRegistry}
            onCheckRegistry={handleRegistryCheck}
            selectedCategory={selectedCategory}
            onSelectCategory={handleCategoryChange}
            selectedProjectVintage={selectedProjectVintage}
            onSelectProjectVintage={handleProjectVintageChange}
            selectedToken={selectedToken}
            onChangeToken={handleTokenCheck}
            selectedCreditType={selectedCreditType}
            onSelectCreditType={handleCreditType}
            selectedCountry={selectedCountry}
            onSelectCountry={handleCountryChange}
            selectedTypeOfTransaction={selectedTypeOfTransaction}
            onSelectTypeOfTransaction={handleTypeOfTransaction}
            min={lowPrice} // Pass lowPrice to the dialog
            max={highPrice} // Pass highPrice to the dialog
            setLowPrice={setLowPrice} // Function to update lowPrice
            setHighPrice={setHighPrice}
            showProject={showProject}
            onCheckType={handleTypeCheck}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            selectedUserType={selectedUserType}
            onCheckUserType={handleUserTypeCheck}
          />
        )}
        <InquireNotificationDialog
          open={inquireNotificationState}
          isLoggedIn={userType !== null}
          onCancel={() => setInquireNotificationState(false)}
        />
        <InquireConfirmation
          open={inquireConfirmState}
          onCancel={() => setInquireConfirmState(false)}
        />
        <KycDialogBox
          open={kycDialogState}
          onCancel={() => setKycDialogState(false)}
        />
      </div>
    </>
  );
};

export default ProjectDetails;
